{
  "actions.activate": "Activate",
  "actions.add": "Add",
  "actions.add_deadline": "Add Deadline",
  "actions.addresses": "Addresses",
  "actions.ai_translation": "AI Translation",
  "actions.apply": "Apply",
  "actions.cancel": "Cancel",
  "actions.continue": "Continue",
  "actions.copy_email": "Copy E-mail",
  "actions.copy_link": "Copy link",
  "actions.create": "Create",
  "actions.create_box": "Create box",
  "actions.create_file": "Create file",
  "actions.deactivate": "Deactivate",
  "actions.delete": "Delete",
  "actions.disabled": "disabled",
  "actions.download": "Download",
  "actions.duplicate": "Duplicate",
  "actions.edit": "Edit",
  "actions.edit_deadline": "Edit deadline",
  "actions.folder": "New Folder",
  "actions.install_app": "Install DeepBox app",
  "actions.language": "Language",
  "actions.load_more": "Load more...",
  "actions.login": "Login",
  "actions.logout": "Logout",
  "actions.manage": "Manage",
  "actions.manage_your_account": "Manage your account",
  "actions.more": "More...",
  "actions.more_boxes": "More Boxes...",
  "actions.move": "Move",
  "actions.move_to": "Move to {nodeName}",
  "actions.new": "New",
  "actions.new_entry": "New entry",
  "actions.no": "No",
  "actions.ok": "Ok",
  "actions.open_details": "Open details",
  "actions.open_service": "Open {service}",
  "actions.preview": "Preview",
  "actions.refresh": "Refresh",
  "actions.remove": "Remove",
  "actions.rename": "Rename",
  "actions.reset": "Reset",
  "actions.reset_search": "Reset search",
  "actions.save": "Save",
  "actions.select": "Select",
  "actions.try_again": "Try again",
  "actions.upload": "Upload",
  "actions.upload_file": "Upload files",
  "actions.upload_folder": "Upload folder",
  "actions.view": "View",
  "actions.yes": "Yes",
  "admin.navigation.account": "ACCOUNT",
  "admin.navigation.account_profile": "Your Profile",
  "admin.navigation.organization": "Organization Info",
  "admin.navigation.organization_boxes": "Boxes",
  "admin.navigation.organization_boxes_tags": "Tags",
  "admin.navigation.organization_groups": "Groups",
  "admin.navigation.organization_personal": "Personal info",
  "admin.navigation.organization_subheader": " ORGANIZATION",
  "admin.navigation.organization_subscription": "Subscription",
  "admin.navigation.organization_users": "Users",
  "admin.navigation.organization_verification_in_progress": "Verification",
  "alerts.aba_ninja.continue_process": "This box is linked to DeepNinja.",
  "alerts.box.only_advanced_box_selectable": "Only a box of the type \"Advanced\" may be selected.",
  "alerts.company_accounting.open_invoices.action": "To the invoices",
  "alerts.company_accounting.open_invoices.label": "Payment pending",
  "alerts.company_accounting.open_invoices.member.content": "There is at least one unpaid invoice on your organisation. Please inform the organisation Owner, as unpaid invoices may result in deactivation of the organisation.",
  "alerts.company_accounting.open_invoices.owner.content": "You have at least one unpaid invoice. Please settle it to avoid deactivation of your organisation.",
  "alerts.company_accounting.overusing.action": "Please check your subscription.",
  "alerts.company_accounting.overusing.label": "Capacity overuse",
  "alerts.company_accounting.overusing.member.content": "More capacity is currently used for the organisation than what is available through the subscription. Overuse of capacity may cause the organisation to be disabled. Please inform the owner of the organisation.",
  "alerts.company_accounting.overusing.owner.content": "Your organisation is currently using more capacity than your subscription includes. Please upgrade your subscription or reduce usage to avoid deactivation of the organisation.",
  "alerts.company_verification.action": "Proceed",
  "alerts.company_verification.content": "The verification process is running. You can create the first box as soon as the verification is completed.",
  "alerts.company_verification.title": "Verification",
  "alerts.hoop.continue_process": "This box is linked to Hoop. You can check the status of the company incorporation/mutation at any time at Hoop.",
  "alerts.portal.continue_process": "This box is linked to DeepPortal.",
  "api.deepbox.errors.node.move.out-of-box.prohibited.generic-folder": "Cannot move generic folder to another box. | {n} generic folders cannot move to another box.",
  "api.deepbox.errors.node.move.out-of-box.prohibited.shared-folder": "Cannot move shared folder to another box. | {n} shared folders cannot move to another box.",
  "api.deepbox.errors.node.move.recursive": "A parent folder cannot be moved to a child folder. | {n} parent folders cannot be moved to a child folder.",
  "apps.subtitle.deepbox": "Securely store and share documents",
  "apps.subtitle.deepsign": "Secure legally valid electronic signatures",
  "base.date_picker.example_date": "Ex: {example}",
  "base.date_picker.modal_btn_cancel": "Cancel",
  "base.date_picker.modal_btn_save": "Take over",
  "box.boxes_switch": "Boxes",
  "box.n_selected_detail": "1 selected ({detail}) | {n} selected ({detail})",
  "box.policies.can_not_access_inbox_and_files.text": "You do not have permission to move files to the selected location",
  "box.private.generics.deepmail.error.logged_in_wrong_account.message": "You are currently logged in with the user <b>{userEmail}</b><br />The encrypted message was sent to the email address <b>{queryEmail}</b>. You will need to sign in with this email address.",
  "box.private.generics.deepmail.error.logged_in_wrong_account.title": "You are logged in with the wrong account",
  "box.private.generics.deepmail.title": "DeepMail",
  "box.private.generics.deepsign.banner.content": "In the DeepSign storage, you will find all completed documents. For pending or new signature processes, please switch to the {link}",
  "box.private.generics.deepsign.banner.link": "DeepSign application",
  "box.private.generics.deepsign.title": "DeepSign Storage",
  "box.types.advanced": "Advanced Box",
  "box.types.advanced_per_use": "Advanced Box with fixed price",
  "box.types.portal": "Portal",
  "box.types.simple": "Simple Box",
  "box_details.access.error.forbidden": "Folder does not exist or you do not have permission to access this folder.",
  "box_details.archive.banner.subtitle": "Verifiable integrity",
  "box_details.archive.banner.text": "Immutable · Retained for 10 years from receipt · Qualified timestamp according to ZertES",
  "box_details.all_files_reviewed": "All files are reviewed.",
  "box_details.details_drawer.amount": "Amount",
  "box_details.details_drawer.attributes": "Attributes",
  "box_details.details_drawer.category": "Category",
  "box_details.details_drawer.comments": "Comments",
  "box_details.details_drawer.created": "Created",
  "box_details.details_drawer.details": "Details",
  "box_details.details_drawer.details_file": "File details",
  "box_details.details_drawer.details_folder": "Folder details",
  "box_details.details_drawer.file": "File",
  "box_details.details_drawer.files": "Documents",
  "box_details.details_drawer.folder": "Folder",
  "box_details.details_drawer.location": "Location",
  "box_details.details_drawer.me": "Me",
  "box_details.details_drawer.modified": "Modified",
  "box_details.details_drawer.opened": "Opened",
  "box_details.details_drawer.owner": "Owner",
  "box_details.details_drawer.path": "Path",
  "box_details.details_drawer.queue": "Inbox",
  "box_details.details_drawer.sections.comments.counter": "Comment  | Comments",
  "box_details.details_drawer.sections.comments.text_add": "Add comment",
  "box_details.details_drawer.sections.deep_validator.actions.processing": "Processing...",
  "box_details.details_drawer.sections.deep_validator.actions.re_validate": "Re-validate",
  "box_details.details_drawer.sections.deep_validator.actions.validate": "Validate",
  "box_details.details_drawer.sections.deep_validator.jurisdiction": "Jurisdiction",
  "box_details.details_drawer.sections.deep_validator.jurisdictions.Unknown": "Unknown Jurisdiction",
  "box_details.details_drawer.sections.deep_validator.jurisdictions.ZertES": "ZertES",
  "box_details.details_drawer.sections.deep_validator.jurisdictions.eIDAS": "eIDAS",
  "box_details.details_drawer.sections.deep_validator.n_signature_status.indeterminate": "1 undetermined signature | {n} undetermined signatures",
  "box_details.details_drawer.sections.deep_validator.n_signature_status.invalid": "1 invalid signature | {n} invalid signatures",
  "box_details.details_drawer.sections.deep_validator.n_signature_status.unsupported": "1 unsupported signature | {n} unsupported signatures",
  "box_details.details_drawer.sections.deep_validator.n_signature_status.valid": "1 valid signature | {n} valid signatures",
  "box_details.details_drawer.sections.deep_validator.no_signatures_found": "No signatures found",
  "box_details.details_drawer.sections.deep_validator.nr_of_signatures": "Number of signatures",
  "box_details.details_drawer.sections.deep_validator.signature_type": "Signature type",
  "box_details.details_drawer.sections.deep_validator.signature_types.CH_QESeal": "Qualified Electronic Seal",
  "box_details.details_drawer.sections.deep_validator.signature_types.CH_QESig": "Qualified Electronic Signature",
  "box_details.details_drawer.sections.deep_validator.signature_types.CH_RegESeal": "Regulated Electronic Seal",
  "box_details.details_drawer.sections.deep_validator.signature_types.CH_RegESig": "Regulated Electronic Signature",
  "box_details.details_drawer.sections.deep_validator.signature_types.Indeterminate_QESeal": "Qualified electronic seal (indeterminate)",
  "box_details.details_drawer.sections.deep_validator.signature_types.Indeterminate_QESig": "Qualified electronic signature (indeterminate)",
  "box_details.details_drawer.sections.deep_validator.signature_types.Indeterminate_Unknown": "Indeterminate electronic signature",
  "box_details.details_drawer.sections.deep_validator.signature_types.Not_AdES": "Invalid electronic signature",
  "box_details.details_drawer.sections.deep_validator.signature_types.Not_AdES_but_QC": "Qualified electronic signature (invalid)",
  "box_details.details_drawer.sections.deep_validator.signature_types.Not_AdES_but_QC_with_QSCD": "Qualified electronic signature (invalid)",
  "box_details.details_drawer.sections.deep_validator.signature_types.QESeal": "Qualified Electronic Seal",
  "box_details.details_drawer.sections.deep_validator.signature_types.QESig": "Qualified Electronic Signature",
  "box_details.details_drawer.sections.deep_validator.signature_types.Unknown": "Unknown signature type",
  "box_details.details_drawer.sections.deep_validator.time_of_signature": "Signature time",
  "box_details.details_drawer.sections.deep_validator.validation_result_indication": "Result of signature verification",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.FAILED": "Signature is invalid",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.INDETERMINATE": "Signature is undefined",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.NO_SIGNATURE_FOUND": "No signature found",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.PASSED": "Signature is valid",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.TOTAL_FAILED": "Signature is invalid",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.TOTAL_PASSED": "Signature is valid",
  "box_details.details_drawer.sections.deep_validator.validation_results": "Exam results",
  "box_details.details_drawer.sections.tags.assign": "Assign tags",
  "box_details.details_drawer.sections.tags.counter": "Tag | Tags",
  "box_details.details_drawer.size": "Size",
  "box_details.details_drawer.tags": "Tags",
  "box_details.details_drawer.trash": "Trash",
  "box_details.folder_is_empty": "This folder is empty.",
  "box_details.items": "1 Item | {n} Items",
  "box_details.load_more": "Load More",
  "box_details.more": "More",
  "box_details.more_items": "+1 more item | +{n} more items",
  "box_details.navigation.deadlines": "Deadlines",
  "box_details.navigation.files": "Documents",
  "box_details.navigation.hint": "Hint: Double-click to navigate",
  "box_details.navigation.inbox": "Inbox",
  "box_details.navigation.info_no_sub_folder": "This folder does not contain any subfolders",
  "box_details.navigation.queue": "Inbox",
  "box_details.navigation.trash": "Trash",
  "box_details.no_items": "No items",
  "box_details.trash.empty": "Trash is empty",
  "box_details.trash.info.empty": "Items in the trash will be deleted permanently after 30 days. {link}",
  "box_details.trash.info.with_files": "Items in the trash will be deleted permanently after 30 days.",
  "buttons.back": "Back",
  "buttons.cancel": "Cancel",
  "buttons.confirm": "Confirm",
  "buttons.continue": "Continue",
  "buttons.discard": "Discard",
  "buttons.done": "Done",
  "buttons.ignore_dev_int_only": "Ignore [DEV/INT only]",
  "buttons.login": "Login",
  "buttons.login_now": "Login now",
  "buttons.proceed": "Proceed",
  "buttons.save": "Save",
  "buttons.save_and_continue": "Save and continue",
  "buttons.save_and_verify": "Save and verify",
  "buttons.send": "Send",
  "buttons.start_now": "Start now",
  "buttons.to_deepbox": "To DeepBox",
  "buttons.upload": "Upload",
  "choose_your_box": "Choose your box",
  "confirmation.delete_multiple_nodes_description": "Are you sure you want to delete this item? | Are you sure you want to delete {n} items?",
  "confirmation.delete_multiple_nodes_title": "Delete",
  "confirmation.delete_permanently_description": "Are you sure you want to delete {name} permanently?  | Are you sure you want to delete permanently {count} items?",
  "confirmation.delete_permanently_title": "Delete Permanently",
  "confirmation.empty_trash_description": "Are you sure you want to delete all items in trash?",
  "confirmation.empty_trash_title": "Empty Trash",
  "confirmation.save_open_changes.msg": "You have made changes. Do you want to discard or save them?",
  "confirmation.save_open_changes.title": "Review changes",
  "dashboard.private.generics.deepmail.banner.subtitle": "Your private inbox for securely receiving sensitive files.",
  "dashboard.private.generics.deepmail.banner.title": "DeepMail",
  "dashboard.private.generics.deepsign.banner.subtitle": "Storage for completed DeepSign documents",
  "dashboard.private.generics.deepsign.banner.title": "DeepSign Storage",
  "dashboard.service.card.deepbox.btn": "Complete DeepCloud account",
  "dashboard.service.card.deepbox.btn_manage": "Manage",
  "dashboard.service.card.deepbox.content": "To use DeepBox yourself, you need to complete your account. {link}",
  "dashboard.service.card.deepbox.create_box.btn": "Create Box",
  "dashboard.service.card.deepbox.create_box.content": "Create your first box free of charge to use the Swiss all-in-one platform for secure document exchange.",
  "dashboard.service.card.deepbox.create_box.content_empty_boxes": "No boxes could be found.",
  "dashboard.service.card.deepbox.create_box.content_empty_boxes_can_not_onboard": "You do not have the necessary rights to create a box. <br />\nContact an owner or admin of your organisation.",
  "dashboard.service.card.deepbox.onboarding_in_progress.btn": "Continue Onboarding",
  "dashboard.service.card.deepbox.onboarding_in_progress.content": "You need to finish the Onboarding process in order to use DeepBox yourself. {link}",
  "dashboard.service.card.deepsign.content": "Securely sign documents electronically.",
  "dashboard.service.card.deepsign.no_pending_signs": "There are currently no documents for you to sign.",
  "dashboard.service.card.deepsign.onboarding_in_progress.btn": "Continue DeepSign Onboarding",
  "dashboard.service.card.deepsign.onboarding_in_progress.content": "Complete the DeepSign Onboarding in order to use DeepSign as an initiator. {link}",
  "dashboard.service.card.deepv.btn": "Manage DeepV",
  "dashboard.service.card.deepv.content": "This account has been opened explicitly for DeepV. You can also use DeepBox or DeepSign with this account if you want to. {link}",
  "dashboard.service.card.deepv.onboarding_in_progress.btn": "Continue DeepV Onboarding",
  "dashboard.service.card.deepv.onboarding_in_progress.content": "Complete the DeepV Onboarding in order to use DeepV. {link}",
  "date.added": "Added",
  "date.am": "AM",
  "date.days": "1 day ago | {num} days ago",
  "date.deleted.days": "1 day ago | {num} days ago",
  "date.deleted.hours": "1 hour ago | {num} hours ago",
  "date.deleted.minutes": "1 minute ago | {num} minutes ago",
  "date.deleted.months": "1 month ago | {num} months ago",
  "date.deleted.now": "right now",
  "date.deleted.years": "1 year ago | {num} years ago",
  "date.expired": "expired",
  "date.hours": "1 hour ago | {num} hours ago",
  "date.in_three_days": "in 3 days",
  "date.in_two_days": "in 2 days",
  "date.minutes": "1 minute ago | {num} minutes ago",
  "date.months": "1 month ago | {num} months ago",
  "date.now": "Right now",
  "date.on": "on",
  "date.opened": "Opened",
  "date.pm": "PM",
  "date.today": "Today",
  "date.tomorrow": "Tomorrow",
  "date.years": "1 year ago | {num} years ago",
  "date.yesterday": "Yesterday",
  "deep_ui_lib.core.footer.link.help": "Help",
  "deep_ui_lib.core.footer.link.impressum": "Impressum",
  "deep_ui_lib.core.footer.link.privacy_policy": "Privacy Policy",
  "deep_ui_lib.core.footer.link.terms_of_service": "Terms of Service",
  "deep_ui_lib.deep_filter_menu.all": "All",
  "deep_ui_lib.deep_filter_menu.clear_selected": "Clear selected items",
  "deep_ui_lib.deep_filter_menu.no_matching_options": "No matching options",
  "deep_ui_lib.deep_filter_menu.use_value": "Use “{value}”",
  "deepa_chat.context_dialog_title": "Chat context ({n} folder) | Chat context ({n} folders)",
  "deepa_chat.context_filter": "Filter folders",
  "deepa_chat.context_label": "Context:",
  "deepa_chat.context_others": "+ {n} other | + {n} others",
  "deepa_chat.empty_state": "Ask DeepA about the folders in this chat's context.",
  "deepa_chat.export.answer": "Answer",
  "deepa_chat.export.context": "Context",
  "deepa_chat.export.file_name": "File name",
  "deepa_chat.export.file_name_prefix": "DeepA chat",
  "deepa_chat.export.format": "Format",
  "deepa_chat.export.formats.docx": "Word (.docx)",
  "deepa_chat.export.formats.html": "HTML (.html)",
  "deepa_chat.export.formats.json": "JSON (.json)",
  "deepa_chat.export.formats.markdown": "Markdown (.md)",
  "deepa_chat.export.formats.pdf": "PDF (.pdf)",
  "deepa_chat.export.formats.txt": "Text (.txt)",
  "deepa_chat.export.generated_by": "Generated by DeepA",
  "deepa_chat.export.incomplete_answer": "This answer is incomplete.",
  "deepa_chat.export.leftover_file": "The temporary Word file \"{name}\" could not be removed.",
  "deepa_chat.export.location": "Save to",
  "deepa_chat.export.no_write_permission": "You can't save files in this folder.",
  "deepa_chat.export.question": "Question",
  "deepa_chat.export.success": "Chat exported as \"{name}\"",
  "deepa_chat.export.title": "Export chat",
  "deepa_chat.new_chat": "New chat",
  "deepa_chat.new_chat_hint": "New chat about the selected folders, or the current folder if no folder is selected",
  "deepa_chat.prompt_placeholder": "Ask DeepA…",
  "deepa_chat.reply_stopped": "Reply stopped",
  "deepa_chat.start_chat_for": "Start chat for \"{name}\"",
  "deepa_chat.stop": "Stop",
  "deepa_chat.title": "DeepA Chat",
  "deepmail.error.logged_in_wrong_account.message": "You are currently logged in with the user <b>{userEmail}</b>.<br />\nThe DeepMail was sent to the email address <b>{queryEmail}</b>.<br />\nPlease log in with the correct account.",
  "deepmail.error.logged_in_wrong_account.title": "Logged in with wrong account",
  "deeppay.payment_order.execution_date": "Execution date",
  "deeppay.payment_order.info_line": "Info line",
  "deeppay.payment_order.move_file_message": "Would you like to move the file to the \"{folderName}\" folder?",
  "deeppay.payment_order.order_details": "Order details",
  "deeppay.payment_order.pay_now": "Pay now",
  "deeppay.payment_order.payment": "Payment",
  "deeppay.payment_order.payment_amount": "Payment amount",
  "deeppay.payment_order.payment_reference": "Payment reference",
  "deeppay.payment_order.recipient": "Recipient",
  "deeppay.payment_order.xml_download": "Download XML",
  "deeppay.payment_order.yes_move": "Yes, move",
  "deeppay.payments_history.by_address_dialog.amount": "Amount",
  "deeppay.payments_history.by_address_dialog.created_at": "Transmitted at",
  "deeppay.payments_history.by_address_dialog.created_by": "Transmitted by",
  "deeppay.payments_history.by_address_dialog.destination_iban": "Recipient IBAN",
  "deeppay.payments_history.by_address_dialog.payment_to": "Payments to \"{destination}\"",
  "deeppay.payments_history.by_address_dialog.status": "Status",
  "deeppay.payments_history.card_expandable.title": "Payments history",
  "deeppay.payments_history.list.created_by": "Transmitted by",
  "deeppay.payments_history.list.destination": "Destination",
  "deeppay.payments_history.list.status.declined": "Declined",
  "deeppay.payments_history.list.status.paid": "Paid",
  "deeppay.payments_history.list.status.transmitted": "Transmitted",
  "dialogs.add": "Add",
  "dialogs.add_deadline_title": "Add Deadline",
  "dialogs.box": "Box",
  "dialogs.cancel": "Cancel",
  "dialogs.change": "Change",
  "dialogs.close": "Close",
  "dialogs.create": "Create",
  "dialogs.create_new_deepbox.msg": "Do you want to create a free Box?",
  "dialogs.create_new_deepbox.title": "Create Box",
  "dialogs.details": "Details",
  "dialogs.discard.btn": "Discard",
  "dialogs.discard.msg": "Are you sure want to discard all changes?",
  "dialogs.discard.title": "Discard changes",
  "dialogs.download_app_title": "Download app",
  "dialogs.manage_tags": "Manage tags",
  "dialogs.member": "Member",
  "dialogs.members": "Members: all members of ",
  "dialogs.move_items_title": "Move 1 item to... | Move {n} items to...",
  "dialogs.move_to_inbox": "Move to inbox",
  "dialogs.name": "Name",
  "dialogs.newBox": "New Box",
  "dialogs.no": "No",
  "dialogs.node_create_new.error.create": "{fileName} could not be created",
  "dialogs.node_create_new.success.create": "{fileName} successfully created",
  "dialogs.node_create_new.title": "Create new {file} File",
  "dialogs.remove_deadline": "Remove deadline",
  "dialogs.rename": "Rename",
  "dialogs.save": "Save",
  "dialogs.select_location": "Select location",
  "dialogs.session_invalid.btn_login": "Login",
  "dialogs.session_invalid.loggedout.msg": "You have been logged out of DeepBox. Please log in again.",
  "dialogs.session_invalid.loggedout.title": "You have been logged out of DeepBox",
  "dialogs.session_invalid.session_expired.msg": "For security reasons you have been logged out of DeepBox. Please log in again.",
  "dialogs.session_invalid.session_expired.title": "You have been logged out of DeepBox",
  "dialogs.tags.most_used_tags": "Suggestion",
  "dialogs.tags.n_selected": "1 selected | {n} selected",
  "dialogs.tags.title": "Tags",
  "dialogs.tags.toast.success.n_updated": "1 file was successfully updated | {n} files were successfully updated",
  "dialogs.yes": "Yes",
  "drag_drop.msg.error.missing_permissions_to_add_children": "missing permission to add files",
  "drag_drop.msg.error.missing_permissions_to_delete_some_nodes": "1 element can not be deleted because u don't have permission for it. This element will be filtered. | {n} elements can not be deleted because you don not have permission for it. This elements will be filtered.",
  "drag_drop.msg.error.move_to_same_parent": "File cannot be moved because the source folder has been selected. | Files cannot be moved because the source folder has been selected.",
  "drag_drop.msg.error.target_is_one_of_the_nodes_to_be_moved": "Folder can't be moved to itself",
  "drag_drop.msg.success.node_moved_to_target": "Element was successfully moved to the following folder: \"{targetName}\" | Elements were successfully moved to the following folder: \"{targetName}\"",
  "error.403.box_elevated_auth_required.btn_2fa": "Enable 2FA",
  "error.403.box_elevated_auth_required.description": "Access requires a login with two-factor authentication (2FA). Enable 2FA to access the shared content.",
  "error.403.box_elevated_auth_required.link_2fa_info": "More information about 2FA",
  "error.403.box_elevated_auth_required.title": "Access denied",
  "error.403.box_not_found_or_no_access": "Box doesn't exists or you are not authorised to access the Box.",
  "error.403.file": "You are not authorised to access the document.",
  "error.403.file_not_found_or_no_access": "File doesn't exists or you are not authorised to access the document.",
  "error.403.settings": "You are not authorised to access these settings.",
  "error.403.wrong_account_email": "The email of the account you are trying to sign this document with does not match the one the signature request was sent to. Please log out and re-open the link you received by email.",
  "error.413.file_too_big": "File too big",
  "error.axios.ERR_NETWORK": "Connection was interrupted",
  "error.code": "Code",
  "error.codes.ERR_FILE_NOT_FOUND": "File not found",
  "error.codes.KC_ERROR_UPDATE_TOKEN": "Invalid session",
  "error.codes.UPLOAD_PARENT_NODE_ID_CAN_NOT_BE_EMPTY": "The parent node ID cannot be empty",
  "error.download.multiple.n_max_length": "A maximum of {n} selected items can be downloaded at the same time.",
  "error.download.not_possible": "Download not possible",
  "error.email_do_not_match.description": "You are creating an account with the email <b>{newEmail}</b>, but you are still logged in with the following email: <b>{currentEmail}</b>.\n<br />\nPlease log out to create an account with a new email.",
  "error.email_do_not_match.title": "E-mail does not match",
  "error.error_occurred": "An error occurred",
  "error.home": "Home",
  "error.inbox.folders_are_not_allowed": "Folders are not supported in the Inbox. 1 Folder will not be moved. | Folders are not supported in the Inbox. {n} Folders will not be moved.",
  "error.invalid_or_missing_params": "Invalid or missing parameters",
  "error.invalid_param_email": "Invalid email parameter",
  "error.invalid_password": "Password invalid",
  "error.invalid_url_service_param": "Invalid url service parameter",
  "error.key_invalid_or_expired": "Key is invalid or expired",
  "error.logged_out": "You have been logged out",
  "error.login": "Back to login",
  "error.organization_not_found": "Organization not found",
  "error.page_not_found": "Page not found",
  "error.page_not_found_or_missing_permissions": "Page not found or you do not have permissions to access this resource",
  "error.url_invalid": "URL is invalid or expired",
  "error.validation.invalid": "Please check your entry",
  "external_services.aba_ninja.description": "Connect with accounting program",
  "external_services.deepmail.description": "Send Deep Mail",
  "external_services.hoop.description": "Constituting and mutating companies digitally",
  "external_services.title": "Applications enabled by DeepBox",
  "fields.country_select.label": "Select country",
  "fields.errors.invalid_email": "The mail is invalid",
  "fields.errors.invalid_password": "Password doesn't match the validation rules",
  "fields.errors.max_length": "Maximum length of {maxLength} was exceeded",
  "fields.errors.min_length": "Minimum length of {minLength} was not reached",
  "fields.errors.required": "Mandatory field",
  "fields.multi_language_text.btn_add": "Add language",
  "fields.multi_language_text.field_key_label": "Language",
  "fields.multi_language_text.field_value_label": "Text",
  "fields.password.label": "Password",
  "fields.password_with_verification.hint": "At least {counter} characters (letters, digits and symbols)",
  "fields.phone.placeholder": "Enter a phone number",
  "fields.search_for_boxes.placeholder": "Search for Boxes",
  "fields.uid.label": "UID",
  "fields.uid.placeholder.country.ch": "e.g. {example}",
  "fields.uid.placeholder.country.row": "Enter UID",
  "fields.zip_city.city.label": "Location",
  "fields.zip_city.zip.label": "Postal code",
  "form.de": "German",
  "form.email": "email",
  "form.en": "English",
  "form.extension": "Extension",
  "form.fr": "French",
  "form.it": "Italian",
  "form.manage_translations": "Manage translations",
  "form.message": "message",
  "form.name": "Name",
  "form.noDataText": "No data available",
  "form.type": "Type",
  "hints.analysis.failed": "Analysis failed",
  "hints.analysis.running": "Analysing...",
  "hints.expired": "expired",
  "hints.expires": "Expires",
  "hints.n_files": "1 file | {n} files",
  "hints.n_folders": "1 folder | {n} folders",
  "inbox_address.btn_generate": "Generate new address",
  "inbox_address.delete.msg": "Are you sure you want to delete this address?",
  "inbox_address.delete.title": "Delete address",
  "inbox_address.delete_address": "Delete address",
  "inbox_address.description": "Generate unique addresses that can be used to send documents directly to your Inbox via an e-mail or upload dialogue. Anyone with access to these addresses can send you files. Be careful with whom you share them. Addresses can be deactivated at any time. {link}",
  "inbox_address.description_short": "Generate unique addresses that can be used to send documents directly to your Inbox via an e-mail or upload dialogue... {link}",
  "inbox_address.edit.label.description": "Description",
  "inbox_address.edit.label.email_link": "E-mail Link",
  "inbox_address.edit.label.upload_link": "Upload Link",
  "inbox_address.manage_all_addresses": "Manage addresses",
  "inbox_address.title": "Address for this inbox",
  "inbox_address.toast.error.email_disabled": "E-mail link could not be deactivated",
  "inbox_address.toast.error.email_enabled": "E-mail link could not be activated",
  "inbox_address.toast.error.upload_disabled": "Upload link could not be deactivated",
  "inbox_address.toast.error.upload_enabled": "Upload Link could not be activated",
  "inbox_address.toast.success.email_disabled": "E-mail link was successfully deactivated",
  "inbox_address.toast.success.email_enabled": "E-mail link was successfully activated",
  "inbox_address.toast.success.generated": "Address was successfully generated",
  "inbox_address.toast.success.saved": "Address was saved successfully",
  "inbox_address.toast.success.upload_disabled": "Upload link was successfully deactivated",
  "inbox_address.toast.success.upload_enabled": "Upload link was successfully activated",
  "labels.attachments": "Attachments",
  "labels.boxes_shared_with_me": "Shared with me",
  "labels.clear_all": "Clear all",
  "labels.description": "Description",
  "labels.documents_in_inbox": "Document in inbox | Documents in inbox",
  "labels.email": "Email",
  "labels.favorite": "Favorite",
  "labels.favorites": "Favorites",
  "labels.file": "File | Files",
  "labels.files": "file | files",
  "labels.filter": "Filter",
  "labels.folder": "Folder | Folders",
  "labels.insufficient_permissions": "Insufficient permissions",
  "labels.less": "less",
  "labels.load_more": "Load More",
  "labels.menu.actions.favorites.add": "Add to favorites",
  "labels.menu.actions.favorites.remove": "Remove from favorites",
  "labels.more": "more",
  "labels.n_elements_selected": "1 element selected | {n} elements selected",
  "labels.open": "Open",
  "labels.open_dashboard": "Open Dashboard",
  "labels.others": "other | others",
  "labels.recents": "Recents",
  "labels.request_message": "Support request ",
  "labels.section": "Section",
  "labels.show_all": "Show all",
  "labels.show_less": "Show less",
  "labels.show_more": "Show more",
  "labels.suggestions": "Suggestions",
  "labels.valid_from": "Valid from",
  "labels.valid_until": "Valid until",
  "links.read_more": "Learn more",
  "loader.files.are_being_indexed": "File are being indexed...",
  "loader.is_loading": "Loading...",
  "main_view.all": "Show all",
  "main_view.boxes_shared_with_me": "Boxes shared with me",
  "main_view.deadlines": "Deadlines",
  "main_view.favorites": "Favorites",
  "main_view.inbox": "Inbox",
  "main_view.recents": "Recents",
  "main_view.search_for_boxes": "Search for Boxes",
  "messages.error.deepsign_file_max_size": "Only files up to {size} can be signed.",
  "messages.error.deepvalidator_file_max_size": "Only files up to {size} can be opened with DeepValidator.",
  "messages.error.file_size": "Only files up to a size of 2 GB can be uploaded.",
  "messages.no_box_found": "No box was found.",
  "messages.no_boxes_found": "No boxes found",
  "messages.no_boxes_found_title": "No boxes",
  "messages.success.box_created": "Box successfully created",
  "messages.success.copy_of": "Copy of {fileName} successfully created | Copy of {n} files successfully created",
  "messages.success.delete": "1 file moved to trash | {n} files moved to trash",
  "messages.success.delete_permanently": "1 file permanently deleted | {n} files permanently deleted",
  "messages.success.file_converted_to_pdf": "File {fileName} successfully created | {n} PDF files successfully created",
  "messages.success.file_upload": "No items have been uploaded to {destination} | {number} item has been uploaded to {destination} | {number} items have been uploaded to {destination}",
  "messages.success.folder_created": "Folder {name} has been successfully created.",
  "messages.success.folder_upload": "{destination} folder has been created.  |  {destination} folder has been created and {number} item has been uploaded into it | {destination} folder has been created and {number} items have been uploaded into it.",
  "messages.success.move": "No items have been moved to {destination} | {n} item has been moved to {destination} | {n} items have been moved to {destination}",
  "messages.success.move_to_box_element": "No Element was moved to the Folder \"{folderName}\" in the Box \"{boxName}\" | {n} Element was moved to the Folder \"{folderName}\" in the Box \"{boxName}\" | {n} Elements were moved to the Folder \"{folderName}\" in the Box \"{boxName}\"",
  "messages.success.move_to_box_file": "No items have been moved to \"{folderName}\" in \"{boxName}\" | {n} item has been moved to \"{folderName}\" in \"{boxName}\" | {n} items have been moved to \"{folderName}\" in \"{boxName}\"",
  "messages.success.restore": "1 file successfully restored | {n} files successfully restored",
  "msgbox.btn_agree": "Agree",
  "msgbox.btn_cancel": "Cancel",
  "msgbox.checkbox.validation.required": "Field required",
  "navigation.collapse": "Collapse",
  "navigation.dashboard": "Dashboard",
  "navigation.deepbox_settings": "Box Settings",
  "navigation.deepo_settings": "DeepO Settings",
  "navigation.expand": "Expand",
  "navigation.of": "{currentFile} of {filesNumber}",
  "navigation.recent": "Recent",
  "navigation.recent_boxes": "Recent boxes",
  "navigation.tabs.all": "All boxes",
  "navigation.tabs.favorites": "Favorites",
  "navigation.tabs.files": "Documents",
  "navigation.tabs.inbox": "Inbox",
  "navigation.tabs.recent": "Recent",
  "navigation.tabs.trash": "Trash",
  "no_box.box_name": "My company's box",
  "no_box.button_text": "Setup your own DeepBox",
  "no_box.features.automate_document_processing": "Automate document processing",
  "no_box.features.connect": "Connect with 3rd parties",
  "no_box.features.share_documents": "Share documents with others",
  "no_box.features.store_your_documents": "Store your own documents",
  "no_box.title": "Samplecompany SA",
  "node.cloudoffice.msg_box.terms.member.content": "The Microsoft 365 web service has not been enabled for your organization. {link}",
  "node.cloudoffice.msg_box.terms.member.title": "Not unlocked",
  "node.cloudoffice.msg_box.terms.owner.checkbox.label": "I accept the terms.",
  "node.cloudoffice.msg_box.terms.owner.content": "You are using a Microsoft service to process files. Please confirm that you accept the Microsoft terms of use and their privacy policy. Additionally, the terms of use of the DeepCloud REST API apply.",
  "node.cloudoffice.msg_box.terms.owner.title": "Microsoft 365 web",
  "node.download.errors.av_scan_file_too_big.btn.agree": "Download anyway",
  "node.download.errors.av_scan_file_too_big.checkbox.label": "I understand the risks and would like to download the file anyway | I understand the risks and would like to download the files anyway",
  "node.download.errors.av_scan_file_too_big.message": "The file could not be checked for viruses because it is too large. <br />The file could be malicious, so only download it if you understand the risks. | At least one file could not be scanned for viruses because it is too large. <br />\nThe files could be malicious, so only download them if you understand the risks.",
  "node.download.errors.av_scan_file_too_big.title": "Virus Scan failed",
  "node.download.errors.av_scan_virus_found.btn.agree": "Download anyway",
  "node.download.errors.av_scan_virus_found.checkbox.label": "I understand the risks and would like to download the file anyway | I understand the risks and would like to download the files anyway",
  "node.download.errors.av_scan_virus_found.message": "Our virus scanner has found a virus in this file. <br />\nWe recommend that you do not download the file as it may be malicious. | Our virus scanner has found a virus in at least one file. <br />\nWe recommend that you do not download the files as they may be malicious.",
  "node.download.errors.av_scan_virus_found.title": "WARNING: Virus found",
  "node.download.errors.av_scan_virus_found_and_file_too_big.btn.agree": "Download anyway",
  "node.download.errors.av_scan_virus_found_and_file_too_big.checkbox.label": "I understand the risks and would like to download the file anyway | I understand the risks and would like to download the files anyway",
  "node.download.errors.av_scan_virus_found_and_file_too_big.message": "Our virus scanner has detected a virus in this file or this file could not be scanned due to its size.<br />\nWe recommend that you do not download the file as it could be harmful. | Our virus scanner has found a virus in at least one file or at least one file could not be scanned due to its size.  <br />\nWe recommend that you do not download the files as they may be malicious.",
  "node.download.errors.av_scan_virus_found_and_file_too_big.title": "Attention!",
  "node.download.success": "Download starting",
  "node.download.zip_snackbar.generating_zip_file": "Generating ZIP file | Generating {n} ZIP files",
  "node.download.zip_snackbar.zip_download": "ZIP Download",
  "node.preview.errors.av_scan_file_too_big.btn.agree": "View anyway",
  "node.preview.errors.av_scan_file_too_big.checkbox.label": "I understand the risks and would like to view the file anyway | I understand the risks and would like to view the files anyway",
  "node.preview.errors.av_scan_file_too_big.message": "This file could not be checked for viruses because it is too large. <br />\nThis file could be malicious, so only download it if you understand the risks.",
  "node.preview.errors.av_scan_file_too_big.title": "Virus Scan failed",
  "node.preview.errors.av_scan_virus_found.btn.agree": "View anyway",
  "node.preview.errors.av_scan_virus_found.checkbox.label": "I understand the risks and would like to view the file anyway",
  "node.preview.errors.av_scan_virus_found.message": "Our virus scanner has found a virus in this file.<br />\nThis file could be malicious, so only view it if you understand the risks.",
  "node.preview.errors.av_scan_virus_found.title": "WARNING: Virus found",
  "node.share_link.errors.av_scan_file_too_big.btn.agree": "Share anyway",
  "node.share_link.errors.av_scan_file_too_big.checkbox.label": "I understand the risks and would like to share the file anyway | I understand the risks and would like to share the files anyway",
  "node.share_link.errors.av_scan_file_too_big.message": "The file <b>{fileName}</b> could not be checked for viruses because it is too large (<b>{fileSize}</b>).<br />\nThe file could be malicious, so only share it if you understand the risks.",
  "node.share_link.errors.av_scan_file_too_big.title": "Virus Scan failed",
  "node.virus.table.headers.file": "File",
  "node.virus.table.headers.virus_signature": "Virus signature",
  "node_data_table.actions.add_deadline": "Add Deadline",
  "node_data_table.actions.analyze": "Analyze",
  "node_data_table.actions.assign_tags": "Add tags",
  "node_data_table.actions.continue_deepsign": "Continue on DeepSign",
  "node_data_table.actions.convert_to_pdf": "Convert to PDF",
  "node_data_table.actions.copy_of": "Make a copy",
  "node_data_table.actions.deepa_chat": "Chat with DeepA",
  "node_data_table.actions.deepmail": "Send with DeepMail",
  "node_data_table.actions.delete_permanently": "Delete permanently",
  "node_data_table.actions.details_deepsign": "View Details on DeepSign",
  "node_data_table.actions.download": "Download",
  "node_data_table.actions.edit": "Edit",
  "node_data_table.actions.edit_deadline": "Edit Deadline",
  "node_data_table.actions.edit_tags": "Edit tags",
  "node_data_table.actions.flow_start": "Start flow",
  "node_data_table.actions.group.actions": "Actions",
  "node_data_table.actions.group.organize": "Organize",
  "node_data_table.actions.hidden": "Hidden",
  "node_data_table.actions.move_to": "Move to",
  "node_data_table.actions.move_to_trash": "Move to trash",
  "node_data_table.actions.pay": "Pay",
  "node_data_table.actions.pdf_compare": "Compare PDFs",
  "node_data_table.actions.rename": "Rename",
  "node_data_table.actions.restore": "Restore",
  "node_data_table.actions.share_link": "Share link",
  "node_data_table.actions.show_details": "Show details",
  "node_data_table.actions.sign": "Sign with DeepSign",
  "node_data_table.actions.summarization": "Summarising with DeepA",
  "node_data_table.headers.date": "Date",
  "node_data_table.headers.deleted.time": "Deleted",
  "node_data_table.headers.deleted.user": "Deleted by",
  "node_data_table.headers.document_type": "Type",
  "node_data_table.headers.location": "Location",
  "node_data_table.headers.modified": "Modified",
  "node_data_table.headers.name": "Name",
  "node_data_table.headers.owner": "Owner",
  "node_data_table.headers.received": "Received",
  "node_data_table.headers.retained_until": "Retained until",
  "node_data_table.headers.signature": "Signature",
  "node_data_table.headers.size": "Size",
  "node_data_table.headers.timestamp": "Timestamp",
  "node_data_table.me": "Me",
  "node_data_table.mobile.sort_keys.largest": "Largest",
  "node_data_table.mobile.sort_keys.name_asc": "Name ascending",
  "node_data_table.mobile.sort_keys.name_desc": "Name descending",
  "node_data_table.mobile.sort_keys.newest": "Newest",
  "node_data_table.mobile.sort_keys.oldest": "Oldest",
  "node_data_table.mobile.sort_keys.smallest": "Smallest",
  "node_data_table.sign": "Sign",
  "node_data_table.tags": "Tags",
  "node_data_table.tags_multiple": "Multiple tags",
  "node_data_table.tooltip.comment": "Comment",
  "node_data_table.tooltip.comments_show": "Show comments",
  "node_data_table.tooltip.sign_status_pending": "Signature(s) pending",
  "node_data_table.tooltip.sign_status_signed": "Fully signed",
  "node_data_table.views.hidden": "Show Hidden Elements",
  "node_data_table.views.list": "Large list",
  "node_data_table.views.list_dense": "List",
  "nodes.convert_to_pdf_and_sign_msg_box.checkbox.label": "Do not show again",
  "nodes.convert_to_pdf_and_sign_msg_box.errors.file_to_big_mb": "The file is too large. The maximum file size is {maxFileSize} MB.",
  "nodes.convert_to_pdf_and_sign_msg_box.msg": "A PDF copy of your file will be created for signing with DeepSign and saved at the same location in your DeepBox.",
  "nodes.convert_to_pdf_and_sign_msg_box.msg_converting_file_to_pdf": "File will be converted to PDF",
  "nodes.convert_to_pdf_and_sign_msg_box.title": "PDF for signing will be created",
  "nodes.files_description_types.audio": "audio file",
  "nodes.files_description_types.document": "document",
  "nodes.files_description_types.file": "file",
  "nodes.files_description_types.image": "image",
  "nodes.files_description_types.video": "video",
  "nodes.upload_card.labels.count_error": "1 failed | {n} failed",
  "nodes.upload_card.labels.count_n_of_total": "{n} of {total} Elements",
  "nodes.upload_card.title": "Uploads",
  "onlyoffice.editor.open_file_location": "Open file location",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.admin_or_member.actions.support": "DeepCloud",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.admin_or_member.text": "There are several outstanding bills that need to be paid. As a result, the account has been locked. Please contact your administrator to have the account unlocked.",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.owner.actions.open_invoices": "To the bills",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.owner.text": "There are several outstanding bills that need to be paid. As a result, the account has been locked. Please pay the outstanding bills to unlock the account.",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.title": "Pending Payments",
  "overlays.overused_subscription.has_overused_box_users.admin_or_member.text": "For what is included in your current subscription, your DeepBox has either too many users or too many boxes in use. Please inform an owner of this DeepBox so that they can adjust the subscription.",
  "overlays.overused_subscription.has_overused_box_users.owner.actions.manage_organization": "Manage organisation",
  "overlays.overused_subscription.has_overused_box_users.owner.actions.manage_subscription": "Manage subscription",
  "overlays.overused_subscription.has_overused_box_users.owner.text": "For what is included in your current subscription, your DeepBox has either too many users or too many boxes in use. Please select an appropriate subscription plan for this DeepBox, or remove users or boxes.",
  "overlays.overused_subscription.has_overused_box_users.title": "A subscription plan must be selected in order to continue using this DeepBox.",
  "overlays.overused_subscription.learn_more": "Learn more about DeepBox subscriptions here: ",
  "overlays.overused_subscription.title": "Subscription plan",
  "page_titles.search_results": "Search results",
  "pages.dashboard.deadlines": "Deadlines",
  "pages.dashboard.empty.text": "Your boxes will be displayed here",
  "pages.dashboard.empty.text_can_not_onboard": "You do not have the necessary rights to create a box. <br />\nContact an owner or admin of your organisation.",
  "pages.dashboard.empty.text_create_box": "Create your first box free of charge to use the Swiss all-in-one platform for secure document exchange.",
  "pages.dashboard.empty.title": "No Box available",
  "pages.dashboard.inbox": "Inbox",
  "pages.dashboard.labels.all_sections": "All Sections",
  "pages.dashboard.labels.display_all_n": "Show all ({n})",
  "pages.dashboard.labels.tabs": "Tabs",
  "pages.dashboard.onboarding.banner.actions.continue": "Continue onboarding",
  "pages.dashboard.onboarding.banner.text_in_progress": "To use a DeepBox yourself, you must complete the onboarding process.",
  "pages.dashboard.onboarding.banner.text_not_started": "To use DeepBox yourself, you need to complete your account.",
  "pages.dashboard.private_box_title": "For you",
  "pages.links.alert_info": "This link will expire in 1 day | This link will expire in {n} days",
  "pages.links.alert_msg_date_expired": "The link is expired",
  "pages.links.btn_download": "Download",
  "pages.links.btn_view": "View",
  "pages.links.file_preview_not_available": "The file can't be previewed.",
  "pages.store.services.aba_ninja.category": "Accounting",
  "pages.store.services.aba_ninja.content": "<div>\nDeepNinja is the accounting program that allows you to easily manage your company's finances. The efficient tool for offers, invoices, payments, time recording and much more, supports you with the administrative tasks. Thanks to the new DeepBox/DeepNinja connection, documents can be easily exchanged and then automatically processed directly with the accounting program.\n</div>\n<br />\n<div>\nWith this, you can directly open an DeepNinja account and connect it to your DeepBox.\n</div>\n<div class=\"mt-4\">Your advantages:</div>\n<ul>\n  <li>Create offers & invoices and store them in DeepBox</li>\n  <li>Automatic processing of supplier invoices with DeepBox</li>\n  <li>Simple time and service entry</li>\n  <li>Direct connection to Abacus ERP financial accounting</li>\n</ul>",
  "pages.store.services.aba_ninja.languages": "German, French, Italian, English",
  "pages.store.services.aba_ninja.price": "CHF 21.- per month",
  "pages.store.services.aba_ninja.subtitle": "Accounting program",
  "pages.store.services.aba_ninja.title": "DeepNinja",
  "pages.store.services.hoop.category": "Company incorporation",
  "pages.store.services.hoop.content": "<div>\nHoop is an innovative App offered by DeepBox to trustees for the incorporation of companies through an easy and fully digital process. From entering the incorporation data to creating capital deposits bank account of the company and registering it in the registry of commerce, the process is fully digital in every stage.\n</div>\n<div class=\"mt-4\">Advantages:</div>\n<ul>\n  <li>Easy and fully digital process</li>\n  <li>Hoop as a single point of contact for everything</li>\n  <li>Online opening of the capital deposits bank account</li>\n  <li>Notary Public certification with integrated digital signature</li>\n  <li>All documents centrally archived on DeepBox</li>\n</ul>\n<div class=\"mt-4\">Legal forms accepted:</div>\n<ul>\n  <li>Sole proprietorship</li>\n  <li>Limited Liability Company (LLC.)</li>\n  <li>Limited Company (Ltd)</li>\n</ul>",
  "pages.store.services.hoop.languages": "German, French, Italian, English",
  "pages.store.services.hoop.links.contact": "Contact Us",
  "pages.store.services.hoop.links.title": "Hoop Corporate Services SA",
  "pages.store.services.hoop.links.website": "Website",
  "pages.store.services.hoop.price": "CHF 490.- per incorporation ",
  "pages.store.services.hoop.subtitle": "A Digital Company Incorporation Process",
  "pages.store.services.hoop.title": "Hoop – Company incorporation",
  "pages.upload.add_more_files": "Add more files",
  "pages.upload.dialog_unsupported_files.text": "It has 1 unsupported file.\nThis file will not be uploaded.\n | It has {n} unsupported files.\nThese files will not be uploaded.",
  "pages.upload.dialog_unsupported_files.title": "Files not supported",
  "pages.upload.errors.invalid_url": "The upload page is not valid. Please contact an administrator of this DeepBox.",
  "pages.upload.errors.not_found": "The files could not be uploaded. Please reload the page.",
  "pages.upload.errors.upload_failed": "Some files could not be uploaded. Please try again",
  "pages.upload.text_intro": "Direct Upload allows you to submit files directly to the Box {box} of {organization}.",
  "pages.upload.text_link_validity": "The upload link expires in {n}.",
  "pages.upload.title": "Upload files",
  "pages.upload.upload_error": "1 file could not be uploaded | {n} files could not be uploaded",
  "pages.upload.upload_success": "1 file have been uploaded successfully | {n} files have been uploaded successfully",
  "placeholders.enter_support_request": "Enter your request description here...",
  "placeholders.filter_by_owner": "Filter by owner",
  "placeholders.filter_by_tags": "Filter by tags",
  "placeholders.search": "Search...",
  "placeholders.search_box": "Search a box...",
  "placeholders.search_in_box": "Search in {box} ",
  "placeholders.search_tags": "Search tags...",
  "placeholders.select": "Select",
  "pocs.deep_docs.box.filters.changed_by_me.title": "Changed by me",
  "pocs.deep_docs.box.filters.favorites.title": "Favorites",
  "pocs.deep_docs.box.filters.flow.title": "In Flow",
  "pocs.deep_docs.box.filters.recents.title": "Recents",
  "pocs.deep_docs.box.group_by.assignee.title": "Assigned",
  "pocs.deep_docs.box.group_by.document_type.title": "Document type",
  "pocs.deep_docs.box.group_by.flow.title": "Flow",
  "pocs.deep_docs.box.group_by.none.title": "None",
  "pocs.deep_docs.box.group_by.owner.title": "Owner",
  "pocs.deep_docs.box.group_by.project.title": "Project",
  "pocs.deep_docs.box.group_by.type.title": "Type",
  "pocs.deep_docs.node_actions.copy.toast_messages.success": "Copy of {fileName} successfully created | Copy of {n} files successfully created",
  "pocs.deep_docs.node_actions.download.toast.preparing_download": "Your download is being prepared...",
  "pocs.deep_docs.node_actions.move_to.toast_messages.readonly_folders": "Items with read-only permission cannot be moved.",
  "pocs.deep_docs.node_actions.move_to.toast_messages.successfully_moved": "Elements successfully moved",
  "pocs.deep_docs.node_actions.move_to_inbox.errors.no_permission": "No permission for the inbox",
  "pocs.deep_docs.node_actions.move_to_inbox.toast_messages.successfully_moved": "Elements successfully moved to the inbox",
  "pocs.deep_docs.node_details.attributes.assign_to_me": "Assign to me",
  "pocs.deep_docs.pages.assigned.subtitle": "Documents waiting for your action.",
  "pocs.deep_docs.pages.assigned.title": "Assigned to me",
  "pocs.deep_docs.pages.dashboard.subtitle": "This is happening in your workspace right now.",
  "pocs.deep_docs.pages.dashboard.title": "Dashboard",
  "pocs.deep_docs.pages.favorites.subtitle": "Your favorite documents.",
  "pocs.deep_docs.pages.favorites.title": "Favorites",
  "pocs.deep_docs.pages.inbox.subtitle": "Newly received documents.",
  "pocs.deep_docs.pages.inbox.title": "Inbox",
  "pocs.deep_docs.pages.recents.subtitle": "Last updated documents.",
  "pocs.deep_docs.pages.recents.title": "Lastly",
  "pocs.deep_docs.pages.trash.subtitle": "Deleted documents.",
  "pocs.deep_docs.pages.trash.title": "Trash",
  "preview.analyse.btn_action": "Analyze",
  "preview.analyse.loader_is_being_analysed": "Document is being analyzed",
  "preview.analyse.text": "This document has not yet been analyzed.",
  "preview.analyse.toaster.success": "Document was analyzed",
  "preview.cant_be_previewed": "The file can't be previewed.",
  "preview.dialog.password.text": "Please enter the password of the file",
  "preview.dialog.password.text_retry": "Please enter the password of the file again",
  "preview.dialog.password.title": "Password protected file",
  "preview.node_actions.text_download": "Download",
  "preview.node_actions.text_pages": "{currentPage} of {totalPages} pages",
  "preview.node_actions.text_print": "Print",
  "preview.not_available": "No preview available",
  "preview.rendering": "Rendering in  progress...",
  "preview.toaster.error.document_loading_failed": "An error occurred while loading the document. Please retry later.",
  "search.advanced": "Advanced...",
  "search.current": "Current location - {location}",
  "search.enter_some_text": "Enter some text in search field...",
  "search.everywhere": "Everywhere -  {location}",
  "search.in": "In",
  "search.instructions.lede": "Typing in one or more terms is enough for a simple search, the most relevant files appear first. For more targeted queries, combine the operators below.",
  "search.instructions.note.tip1": "Upper and lower case doesn't matter for search terms, <b>report</b> also finds <b>Report</b>.",
  "search.instructions.note.tip2": "A higher number of terms leads to more potential matches. The most relevant results still appear first.",
  "search.instructions.section1.description": "Multiple words broaden the search. Files containing all terms are automatically ranked higher.",
  "search.instructions.section1.example1.description": "All files containing <b>report</b>.",
  "search.instructions.section1.example1.query": "report",
  "search.instructions.section1.example2.description": "<b>report</b> or <b>budget</b>, matches containing both terms rank highest.",
  "search.instructions.section1.example2.query": "report budget",
  "search.instructions.section1.example3.description": "Only the exact phrase <b>annual report 2024</b>.",
  "search.instructions.section1.example3.query": "\"annual report 2024\"",
  "search.instructions.section1.example4.description": "<b>contract</b> or the phrase <b>annual report 2024</b>.",
  "search.instructions.section1.example4.query": "contract \"annual report 2024\"",
  "search.instructions.section1.title": "Search by terms",
  "search.instructions.section2.description": "A leading + makes a term required, a − excludes it.",
  "search.instructions.section2.example1.description": "Must contain <b>report</b>; <b>budget</b> is optional.",
  "search.instructions.section2.example1.query": "+report budget",
  "search.instructions.section2.example2.description": "<b>report</b>, but without <b>draft</b>.",
  "search.instructions.section2.example2.query": "report -draft",
  "search.instructions.section2.example3.description": "Must contain both terms.",
  "search.instructions.section2.example3.query": "+report +budget",
  "search.instructions.section2.example4.description": "Phrase <b>annual report 2024</b>, without <b>draft</b>.",
  "search.instructions.section2.example4.query": "\"annual report 2024\" -draft",
  "search.instructions.section2.title": "Required and excluded terms",
  "search.instructions.section3.description": "The operators must be written in capital letters. Brackets group conditions that belong together.",
  "search.instructions.section3.example1.description": "Must contain both terms.",
  "search.instructions.section3.example1.query": "report AND budget",
  "search.instructions.section3.example2.description": "At least one of the two terms.",
  "search.instructions.section3.example2.query": "invoice OR receipt",
  "search.instructions.section3.example3.description": "<b>report</b>, but without <b>draft</b>.",
  "search.instructions.section3.example3.query": "report NOT draft",
  "search.instructions.section3.example4.description": "(<b>invoice</b> or <b>receipt</b>) and <b>2024</b>.",
  "search.instructions.section3.example4.query": "(invoice OR receipt) AND 2024",
  "search.instructions.section3.example5.description": "<b>report</b> and one of the two phrases.",
  "search.instructions.section3.example5.query": "report AND (\"Q3 2024\" OR \"Q4 2024\")",
  "search.instructions.section3.title": "Combining with AND, OR, NOT",
  "search.instructions.title": "Search help",
  "search.location": "Location",
  "search.modified": "Modified",
  "search.modified_14d": "14 days ago",
  "search.modified_1h": "1 hour ago",
  "search.modified_24h": "24 hours ago",
  "search.modified_30d": "30 days ago",
  "search.modified_7d": "7 days ago",
  "search.modified_pick_date": "Pick a date…",
  "search.modified_range_last_12m": "Last 12 months",
  "search.modified_range_last_30d": "Last 30 days",
  "search.modified_range_last_3m": "Last 3 months",
  "search.modified_range_last_7d": "Last 7 days",
  "search.modified_range_month_to_date": "This month",
  "search.modified_range_today": "Today",
  "search.modified_range_year_to_date": "This year",
  "search.more_locations": "More locations",
  "search.no_results": "No results",
  "search.no_results_title": "No items found",
  "search.no_results_title_location": "No items found in {location}",
  "search.owner": "Owner",
  "search.results_found": "No results for \"{searchTerm}\" |  {n} search result for \"{searchTerm}\" |  {n} search results for \"{searchTerm}\"",
  "search.search_everywhere_link": "Search Everywhere",
  "search.select_location": "Select location...",
  "search.tags": "Tags",
  "search.title": "Search results",
  "seo.description": "Easy, automated and secure document sharing from DeepCloud. Features advanced integrations with Abacus, Switzerland's leader in business ERP software.",
  "services.download.snackbar.generate_in_progress": "Generating a ZIP file...",
  "services.download.snackbar.generate_success": "ZIP created. Downloading…",
  "store.app_bar.btn_cancel": "Cancel",
  "store.app_bar.title": "Applications enabled by DeepBox",
  "store.services.container.bottom.category": "Category",
  "store.services.container.bottom.languages": "Languages",
  "store.services.container.bottom.price": "Pricing",
  "test.weblate": "Test weblate update from weblate UI",
  "toast.box.favorites.success_added": "Box \"{boxName}\" was successfully added from favorites.",
  "toast.box.favorites.success_removed": "Box \"{boxName}\" was successfully removed from favorites.",
  "toast.error.copy_value": "The value could not be copied",
  "toast.success.copy_value": "Value was successfully copied",
  "tooltip.icons.copy": "Copy",
  "tooltip.icons.deepa_chat": "DeepA chat",
  "tooltip.icons.deepadmin_profile": "Manage your DeepBox",
  "tooltip.icons.delete": "Delete",
  "tooltip.icons.delete_all": "Delete all",
  "tooltip.icons.details_panel": "Detail list",
  "tooltip.icons.download": "Download",
  "tooltip.icons.edit": "Edit",
  "tooltip.icons.help_and_support": "Help/Support",
  "tooltip.icons.move": "Move",
  "tooltip.icons.qr_code": "Scan QR code",
  "tooltip.icons.search_filter": "Search filter",
  "tooltip.icons.search_instructions": "Search help",
  "tooltip.icons.view_raw": "View raw",
  "tooltip.icons.view_rendered": "View rendered",
  "tooltip.open": "Open",
  "upload.dropzone.add_files": "Add files",
  "upload.dropzone.add_files_more": "Add more files",
  "upload.dropzone.default_hint": "Drag & drop or upload files",
  "upload.dropzone.dict_cancel_upload": "Cancel upload",
  "upload.dropzone.dict_fallback_message": "Your browser does not support drag & drop file uploads",
  "upload.dropzone.dict_fallback_text": "Use the form to upload your files",
  "upload.dropzone.dict_file_too_big": "The file is too large. The maximum file size is {'{'}{'{'}maxFilesize{'}'}{'}'} MB.",
  "upload.dropzone.dict_invalid_file_type": "A file of this type cannot be uploaded",
  "upload.dropzone.dict_max_files_exceeded": "You cannot upload any more files",
  "upload.dropzone.dict_remove_file": "Remove file",
  "upload.dropzone.dict_response_error": "The server has rejected your request with status {'{'}{'{'}statusCode{'}'}{'}'}.",
  "upload.dropzone.dict_upload_canceled": "Upload was cancelled",
  "upload.dropzone.files_count_added": "1 file added | {n} files added",
  "upload.dropzone.files_count_unsupported": "{n} not supported",
  "upload.error.axios.ERR_CANCELED": "The upload was cancelled",
  "upload.folders": "folder | folders",
  "upload.hints.drop_here_to_upload_to": "Drop files to upload them to:",
  "upload.items": "file | files",
  "upload.no-permissions": "You do not have permissions to upload files.",
  "upload.no_items": "No uploads",
  "upload.status.added": "Added",
  "upload.status.canceled": "Canceled",
  "upload.status.completed": "Completed",
  "upload.status.error": "Failed",
  "upload.status.processing": "Processing",
  "upload.status.warning": "Warning",
  "upload.uploaded_folders": "{folderName} uploaded. | {folderName} {n} of {total} uploaded.",
  "upload.uploaded_items": "1 item uploaded. | {n} of {total} items uploaded",
  "upload.uploaded_items_with_folders": "1 item uploaded. | {n} of {total} items ({numItems} {items}, {numFolders} {folders}) uploaded.",
  "upload.uploading_folders": "{folderName} uploading. | {folderName} {uploadingCount} of {n} uploading.",
  "upload.uploading_items": "Uploading 1 item. | Uploading {n} of {total} items.",
  "upload.uploading_items_with_folders": "Uploading 1 item. | Uploading {n} of {total} items ({numItems} {items}, {numFolders} {folders}).",
  "upload_qr_code.duration.10_minutes": "10 Minutes",
  "upload_qr_code.duration.1_day": "1 Day",
  "upload_qr_code.duration.1_hour": "1 Hour",
  "upload_qr_code.duration.30_minutes": "30 Minutes",
  "upload_qr_code.duration.5_minutes": "5 Minutes",
  "upload_qr_code.duration.custom": "Custom",
  "upload_qr_code.title": "Scan to upload to {location}",
  "upload_qr_code.valid_for": "Valid for",
  "watches.notifications": "Notification",
  "watches.stop.disable.text": "Would you like to turn off notifications for {location}?\nYou will no longer receive emails when new documents are added.",
  "watches.stop.disable.title": "Disable notification?",
  "watches.stop.disabled.text": "The notifications for {location} have been disabled.",
  "watches.stop.disabled.title": "Notification disabled",
  "watches.toast.error.error_on_remove_watch": "Error on remove the watch",
  "watches.toast.error.error_on_start_watch": "Error on start the watch",
  "watches.tooltip": "Notification for new documents in this folder"
}
